/**
 * @module app.bdc.list.loseOrderCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SetOrderReadyForX3IntegrationCtrl(
        $rootScope,
        $uibModalInstance,
        order,
        clientService,
        orderService,
        $log,
        Notification
    ) {
        var self = {};

        self.order = order;
        self.storeId = order.client.storeId;
        let oldStoreId = order.client.storeId;
        self.realDateSignature = moment().toDate();


        self.ready = function() {
            self.order.realDateSignature = moment(self.realDateSignature).format('YYYY-MM-DD');
            // Est ce qu'on a modifié le store id ?
            if (self.storeId !== self.order.client.storeId) {
                clientService
                    .searchClient(self.storeId)
                    .then(function(clients) {
                        if (clients.length === 1) {
                            let client = clients[0];
                            // Valeure par defaut ? bof
                            client.storeActivityId = 6;
                            client.storeType = {
                                id: null,
                                code: null,
                                label: null
                            };
                            return clientService.createUpdate(client).then(function(client) {
                                self.order.client.storeId = self.storeId;
                                return orderService.changeClient(self.order, client).then(function() {
                                    $uibModalInstance.close(true);
                                });
                            });
                        }
                        else {
                            Notification.error('Client Introuvable');
                        }
                    })
                    .catch(function(err) {
                        $log.error(err);
                        self.order.client.storeId = oldStoreId;
                        Notification.error('Une erreur est survenue : ' + err.data);
                    });
            }
            else {
                $uibModalInstance.close(true);
            }
        };

        self.notReady = function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    SetOrderReadyForX3IntegrationCtrl.$inject = [
        '$rootScope',
        '$uibModalInstance',
        'order',
        'clientService',
        'orderService',
        '$log',
        'Notification'
    ];

    angular
        .module('app.bdc.list.setOrderReadyForX3IntegrationCtrl', ['ui.bootstrap.modal'])
        .controller('SetOrderReadyForX3IntegrationCtrl', SetOrderReadyForX3IntegrationCtrl);
});
